var _title;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 152.63 90.31",
  ref: svgRef
}, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "firmament-fileAsset 5")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("line", {
  x1: 8.31,
  y1: 8.65,
  x2: 84.31,
  y2: 81.65,
  style: {
    fill: "none",
    stroke: "#ede4d5",
    strokeMiterlimit: 10,
    strokeWidth: 24
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 144.31,
  y1: 8.65,
  x2: 68.31,
  y2: 81.65,
  style: {
    fill: "none",
    stroke: "#ede4d5",
    strokeMiterlimit: 10,
    strokeWidth: 24
  }
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.919ac276.svg";
export { ForwardRef as ReactComponent };